import textureGrain from "~/images/texture-grain"
import { cn } from "~/common/cn"
import React from "react"

interface TextureGrainBackgroundProps {
  className?: string
}

export const TextureGrainBackground: React.FC<TextureGrainBackgroundProps> = ({ className }) => (
  <div
    className={cn("pointer-events-none absolute left-0 top-0 h-full w-full", className)}
    style={{
      backgroundImage: `url(${textureGrain.src})`,
      backgroundRepeat: "repeat",
      backgroundSize: "100px 100px",
      opacity: 0.15,
    }}
  />
)

export default TextureGrainBackground
